import leng from './leng';

export const NEW_USER_COMPANY = leng.EN.isNewUserCompany.toUpperCase();
export const NEW_USER_PERSON = leng.EN.isNewUserPerson.toUpperCase();
